(function () {
  if (window.topdcDirectCheckoutLoaded) {
    return;
  }

  window.topdcDirectCheckoutLoaded = true;

  function getProductForm(button) {
    const formId = button.getAttribute('form');

    if (formId) {
      const formById = document.getElementById(formId);

      if (formById) {
        return formById;
      }
    }

    return button.closest('form');
  }

  function syncCheckoutButton(button) {
    const form = getProductForm(button);

    if (!form || button.dataset.loading === 'true') {
      return;
    }

    const addToCartButton = form.querySelector(
      '.product-form__submit[name="add"]'
    );

    if (!addToCartButton) {
      return;
    }

    const shouldBeDisabled = addToCartButton.disabled;

    if (button.disabled !== shouldBeDisabled) {
      button.disabled = shouldBeDisabled;
    }
  }

  function syncAllCheckoutButtons() {
    document
      .querySelectorAll('.topdc-direct-checkout')
      .forEach(syncCheckoutButton);
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncAllCheckoutButtons();
  });

  document.addEventListener('change', function (event) {
    const productForm = event.target.closest(
      'form[data-type="add-to-cart-form"]'
    );

    if (!productForm) {
      return;
    }

    setTimeout(syncAllCheckoutButtons, 150);
  });

  const observer = new MutationObserver(function (mutations) {
    const needsSync = mutations.some(function (mutation) {
      if (mutation.type === 'childList') {
        return true;
      }

      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'disabled' &&
        mutation.target.matches &&
        mutation.target.matches('.product-form__submit[name="add"]')
      ) {
        return true;
      }

      return false;
    });

    if (needsSync) {
      syncAllCheckoutButtons();
    }
  });

  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['disabled']
  });

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('.topdc-direct-checkout');

    if (!button) {
      return;
    }

    event.preventDefault();

    if (button.disabled) {
      return;
    }

    const form = getProductForm(button);

    if (!form) {
      console.error('Direct checkout: Product form not found.');
      return;
    }

    const addToCartButton = form.querySelector(
      '.product-form__submit[name="add"]'
    );

    if (addToCartButton && addToCartButton.disabled) {
      return;
    }

    const variantInput = form.querySelector('input[name="id"]');

    if (!variantInput || !variantInput.value) {
      alert('Please select a product option.');
      return;
    }

    const formData = new FormData(form);

    formData.set('id', variantInput.value);

    const quantityInput = form.querySelector('input[name="quantity"]');

    formData.set(
      'quantity',
      quantityInput && quantityInput.value
        ? quantityInput.value
        : '1'
    );

    const textElement = button.querySelector('.btn-text');
    const originalText = textElement
      ? textElement.textContent
      : 'Buy it now';

    button.dataset.loading = 'true';
    button.disabled = true;

    if (textElement) {
      textElement.textContent = 'Redirecting...';
    }

    try {
      const response = await fetch(
        window.Shopify.routes.root + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        }
      );

      const result = await response.json().catch(function () {
        return {};
      });

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'Unable to add this product to the cart.'
        );
      }

      window.location.assign(
        window.Shopify.routes.root + 'checkout'
      );
    } catch (error) {
      console.error('Direct checkout error:', error);

      alert(
        error.message ||
        'Unable to continue to checkout. Please try again.'
      );

      delete button.dataset.loading;

      if (textElement) {
        textElement.textContent = originalText;
      }

      syncCheckoutButton(button);
    }
  });

  syncAllCheckoutButtons();
})();